import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../../../helpers"
import { Context, Transitions } from "../../../types"
import { ResetResult } from "../../../../../../../services/ready-services/studyPlan/studyPlanMutationResolver"

export const resetMasteryLessonTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  exit: assign<Context>({
    selectedLessonId: null,
    selectedSectionId: null
  }),
  invoke: {
    src: "resetMasteryLesson",
    onDone: [
      {
        target: "#StudyPlan.teacher_view",
        actions: assign<Context, DoneInvokeEvent<ResetResult>>((ctx, evt) => ({
          snackbar: {
            message: "Lesson progress reset",
            withUndo: evt.data.allowUndo,
            undoEvent: {
              type: "RESTORE_MASTERY_LESSON",
              contentId: evt.data.contentId,
              allowUndo: false
            }
          }
        }))
      }
    ],
    onError: {
      target: "#StudyPlan.teacher_view.idle",
      actions: assign<
        Context,
        DoneInvokeEvent<{
          response: boolean
          contentId: string
          message: string
        }>
      >((_ctx, evt) => ({
        loading: false,
        selectedLessonId: null,
        selectedSectionId: null,
        snackbar: {
          message: getServiceErrorMessage("toggleResetMasteryLessons", {
            errorReason: evt.data.message
          }),
          withUndo: false,
          error: true
        }
      }))
    }
  }
}
